import { h, Component } from 'preact';
import cn from 'classnames';
import styles from './button.css';

export default class Button extends Component {
  static defaultProps = {
    type: 'primary'
  }

  clickHandler = (event) => {
    const { disabled, onClick } = this.props;

    if (disabled) {
      event.preventDefault();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  }

  render() {
    const { className, children, disabled, submit, type } = this.props;
    const classes = cn(
      styles.button,
      styles[type],
      className,
      {
        [styles.disabled]: disabled
      }
    );

    return (<button
      disabled={disabled}
      type={submit ? 'submit' : 'button'}
      className={classes}
      onClick={this.clickHandler}>
      {children}
    </button>);
  }
}



// WEBPACK FOOTER //
// ./components/button/button.jsx